/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    guard-for-in,
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import EntryDAO from 'dao/EntryDAO';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderSelector from 'file-browser/FolderSelector';
// @ts-expect-error
import drafts from 'notebook/store/data-recovery/Drafts';
// @ts-expect-error
import EntryUtil from 'notebook/util/EntryUtil';
import notifications from 'notifications';
import Modal from 'ui-library/modals/Modal';
import licenses from 'user/Licenses';
import apiutil from 'util/APIUtil';
import * as DateUtil from 'util/DateUtil';
import {typeToName} from 'util/NameUtil';

export const RECOVERY_STATE = {
  ERRORED: 'ERRORED',
  RECOVERED: 'RECOVERED',
};

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  onDismiss: (...args: Array<any>) => any;
}

interface State {
  drafts: Array<any>;
  posting: boolean;
  showAll: boolean;
}
class DataRecoveryModal extends React.Component<Props, State> {
  _isMounted: any;
  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override refs!: {[key: string]: FolderSelector};

  // While drafts.isRecoverable indicates if the draft is allowed to be recovered (permissions, etc.),
  // our recovery process only currently supports entries. We further restrict this to drafts that
  // have not already been recovered/dismissed.
  _computeRecoverable = (apiId: any, recovered: any, dismissed: any): boolean =>
    ModelTypeConstants.ENTRY === apiutil.apiIdToType(apiId) && !recovered && !dismissed;

  isRecoverable = (apiId: any): boolean => {
    const draft = this.getDraft(apiId);
    return this._computeRecoverable(apiId, draft.recovered, draft.dismissed);
  };

  hasUnrecoverableDocumentTypes = (): boolean =>
    this.state.drafts.some((draft) => ModelTypeConstants.ENTRY !== apiutil.apiIdToType(draft.apiId));

  hasFailures = (): boolean => this.state.drafts.some((draft) => draft.status === RECOVERY_STATE.ERRORED);

  recoverData = (): void => {
    this.setState({posting: true});

    const xhrs = [];
    for (const {draftId, cidIdMap, apiId, item, timestamp, folder, selected} of Array.from(
      this.state.drafts
    )) {
      if (selected) {
        assert(this.isRecoverable(apiId), 'data is not recoverable');
        if (this.refs[`${item.id}FolderSelector`].state.fetchedName == null) {
          notifications.error(`Folder must be specified for ${item.name}`);
          this.setState({posting: false});
          return;
        }
        const xhr = EntryDAO.recoverData({
          name: `${item.name} ${DateUtil.readableTime(timestamp)} - RECOVERED`,
          folderId: folder,
          entry: EntryUtil.prepareForSave(item, cidIdMap),
          apiId,
        })
          .done(this.successHandler.bind(this, apiId, draftId, folder))
          .fail(this.failHandler.bind(this, apiId, folder));
        xhrs.push(xhr);
      }
    }

    if (xhrs.length === 0) {
      notifications.error('No files selected.');
      this.setState({posting: false});
      return;
    }

    $.when(...Array.from(xhrs || []))
      .done(() => {
        notifications.success('Files recovered successfully.');
        notifications.close(drafts.RECOVERY_ID);
      })
      .always(() => {
        if (this._isMounted) {
          this.setState({posting: false});
        }
      });
  };

  failHandler = (apiId: any, folder: any, response: any): void => {
    if (!this._isMounted) {
      return;
    }
    analytics.track('data_recovery', 'error', {file_api_id: apiId, folder_api_id: folder});
    notifications.notifyError(response);
    this.updateDraft(apiId, {status: RECOVERY_STATE.ERRORED});
  };

  successHandler = (apiId: any, draftId: any, folder: any, response: any): void => {
    if (!this._isMounted) {
      return;
    }
    analytics.track('data_recovery', 'recover_file', {file_api_id: apiId, folder_api_id: folder});
    this.updateDraft(apiId, {
      status: RECOVERY_STATE.RECOVERED,
      selected: false,
    });
    const localDrafts = drafts.getLocalDrafts();
    localDrafts[draftId].recovered = true;
    drafts.setLocalDrafts(localDrafts);

    FileBrowserActions.openFile(response.id);
  };

  requestRecovery = async (): Promise<void> => {
    await drafts.requestRecovery();
    notifications.success('Data sent. Please contact Benchling support to finish the recovery.', {
      id: drafts.RECOVERY_ID,
    });
  };

  updateSelected = (apiId: any, newSelected: any): void => {
    this.updateDraft(apiId, {selected: newSelected});
  };

  rowClickHandler = (apiId: any, e: any): void => {
    if ($(e.target).is('td') && !this.rowDisabled(apiId)) {
      this.updateSelected(apiId, !this.getDraft(apiId).selected);
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  getDraft = (apiId: any) => _.findWhere(this.state.drafts, {apiId});

  updateDraft = (apiId: any, mergeData: any): void => {
    this.setState({
      drafts: this.state.drafts.map((draft) => {
        if (draft.apiId === apiId) {
          return reactUpdate(draft, {$merge: mergeData});
        } else {
          return draft;
        }
      }),
    });
  };

  rowDisabled = (apiId: any): boolean => !this.isRecoverable(apiId);

  rowStyle = (apiId: any): string => {
    if (this.getDraft(apiId).status === RECOVERY_STATE.RECOVERED) {
      return 'success';
    } else if (this.getDraft(apiId).status === RECOVERY_STATE.ERRORED) {
      return 'danger';
    } else if (this.rowDisabled(apiId)) {
      return 'faded';
    } else {
      return '';
    }
  };

  setFolder = (apiId: any, folder: any): void => {
    this.updateDraft(apiId, {folder});
  };

  dismiss = (): void => {
    this.props.onDismiss();
    notifications.close(drafts.RECOVERY_ID);
    this.props.onRequestClose();
  };

  toggleShowAll = (): void => {
    this.setState({showAll: !this.state.showAll});
  };

  isSubmitDisabled = (): boolean => this.state.posting || this.state.drafts.every((draft) => !draft.selected);

  override state: State = {
    drafts: (() => {
      const result = [];
      const object = drafts.getLocalDrafts();
      for (const draftId in object) {
        const draft = object[draftId];
        if (drafts.isRecoverable(draft)) {
          const {item, timestamp, recovered, dismissed, cidIdMap} = draft;
          const apiId = drafts.apiIdFromDraftId(draftId);
          result.push({
            apiId,
            cidIdMap,
            dismissed,
            draftId,
            folder: item.folder != null ? item.folder.api_identifier : undefined,
            item,
            recovered,
            selected: this._computeRecoverable(apiId, recovered, dismissed),
            status: recovered ? RECOVERY_STATE.RECOVERED : null,
            timestamp,
          });
        }
      }
      return result;
    })(),
    posting: false,
    showAll: false,
  };

  override render(): JSX.Element {
    return (
      <Modal
        enableRedesign={false}
        title="Recover Data"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.recoverData}
        buttons={[
          {key: 'dismiss', text: 'Dismiss', onClick: this.dismiss, style: 'danger', pullLeft: true},
          {key: 'recover', text: 'Recover', submit: true, disabled: this.isSubmitDisabled()},
          {key: 'cancel', text: 'Close', cancel: true, disabled: this.state.posting},
        ]}
      >
        {/* Disabled for now until we find a less-noisy way of assisting recovery. */}
        <p>
          Select the entries below that you wish to auto-recover. A recovered copy of each entry will be
          placed into its selected folder.
        </p>
        {this.hasUnrecoverableDocumentTypes() && (
          <p>Note: non-entry files cannot be auto-recovered at the moment.</p>
        )}
        {licenses.hasEnterprisePlan() && (this.hasUnrecoverableDocumentTypes() || this.hasFailures()) && (
          <p>
            <a onClick={() => this.requestRecovery()}>Click here</a> to request manual recovery.
          </p>
        )}
        <table className="table table-hover table-condensed table-valign-middle-cells">
          <thead>
            <tr>
              <th />
              <th>Type</th>
              <th>Name</th>
              <th>Modified</th>
              <th>Folder</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              if (this.state.drafts.length === 0) {
                return (
                  <tr>
                    <td colSpan={5}>No unsaved drafts found.</td>
                  </tr>
                );
              } else {
                let hiddenExists = false;
                const rows = (() => {
                  const result = [];
                  for (const {apiId, item, timestamp, recovered, dismissed} of Array.from(
                    this.state.drafts
                  )) {
                    if (!this.state.showAll && (recovered || dismissed)) {
                      hiddenExists = true;
                      continue;
                    }
                    result.push(
                      <tr
                        key={apiId}
                        onClick={this.rowClickHandler.bind(this, apiId)}
                        className={this.rowStyle(apiId)}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={this.getDraft(apiId).selected}
                            onChange={(e) => {
                              this.updateSelected(apiId, e.target.checked);
                            }}
                            disabled={this.rowDisabled(apiId)}
                          />
                        </td>
                        <td>{typeToName(apiutil.apiIdToType(apiId))}</td>
                        <td>{item.name}</td>
                        <td>{DateUtil.readableTime(timestamp)}</td>
                        <td>
                          <FolderSelector
                            ref={`${apiId}FolderSelector`}
                            readOnly={this.rowDisabled(apiId)}
                            showNotebook={true}
                            value={this.getDraft(apiId).folder}
                            onChange={(e) => {
                              this.setFolder(apiId, e.target.value);
                            }}
                            unsetOnFetchFail={true}
                          />
                        </td>
                      </tr>
                    );
                  }
                  return result;
                })();
                if (hiddenExists || this.state.showAll) {
                  rows.push(
                    <tr key="toggle-show-all">
                      <td colSpan={5}>
                        <a onClick={this.toggleShowAll}>
                          {this.state.showAll
                            ? 'Hide recovered or dismissed drafts.'
                            : 'Show all unsaved drafts.'}
                        </a>
                      </td>
                    </tr>
                  );
                }
                return rows;
              }
            })()}
          </tbody>
        </table>
      </Modal>
    );
  }
}

export default DataRecoveryModal;
